import { type Node, type NodeProps } from '@xyflow/react';
import { setNodeAdditionalPropertiesModalOpen } from 'automations/store/reactFlowSlice';
import { didNodeSyncToServer } from 'automations/utils/node';
import { useCallback } from 'react';

import { useAutomationDispatch } from './useAutomationDispatch';

export default function useCommonNodeHandles(node: NodeProps<Node<any>>) {
  const dispatch = useAutomationDispatch();
  const open = node.data.menuOpen ?? false;

  const setMenuOpen = useCallback((value: boolean) => {
    dispatch(setNodeAdditionalPropertiesModalOpen({ nodeId: node.id, open: value }));
  }, [dispatch, node.id]);

  const isSyncedToServer = didNodeSyncToServer(node);

  const contentMode = isSyncedToServer ? 'edit' : 'create' as 'edit' | 'create';

  return {
    open,
    setMenuOpen,
    contentMode,
  };
}
